export default __webpack_public_path__ + "locales/es/DownloadDialog.json?hash=e0de96a518bfdae5e8a1b151902f6cf3";